import { render, staticRenderFns } from "./fleg-comp-isr-porel-pago-del-finiquito-porel-retiro-voluntario.vue?vue&type=template&id=f5501cba&lang=html&"
import script from "./fleg-comp-isr-porel-pago-del-finiquito-porel-retiro-voluntario.vue?vue&type=script&lang=js&"
export * from "./fleg-comp-isr-porel-pago-del-finiquito-porel-retiro-voluntario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports